/**
 * Shared interface for all procedural stages.
 *
 * Each stage exposes:
 *  - The Three.js group to add to the scene
 *  - World position
 *  - The audio anchor (where PositionalAudio listens from)
 *  - The video screen plane (for the YouTube CSS3D overlay)
 */

import * as THREE from 'three';

export interface StageHandle {
  id: string;
  label: string;
  group: THREE.Group;
  position: THREE.Vector3;
  audioAnchor: THREE.Object3D;
  audioFalloff: { ref: number; max: number };
  /** World-space corners of the screen quad (TL, TR, BR, BL) for CSS3D overlay. */
  screenQuad: THREE.Vector3[];
  screenWidth: number;
  screenHeight: number;
}

export interface StageColliderRequest {
  x: number;
  z: number;
  radius: number;
  height: number;
}

export function makeScreenQuad(
  center: THREE.Vector3,
  width: number,
  height: number,
  facingYaw: number
): THREE.Vector3[] {
  const right = new THREE.Vector3(Math.cos(facingYaw), 0, -Math.sin(facingYaw));
  const up = new THREE.Vector3(0, 1, 0);
  const halfW = width / 2;
  const halfH = height / 2;
  return [
    center.clone().addScaledVector(right, -halfW).addScaledVector(up, halfH),
    center.clone().addScaledVector(right, halfW).addScaledVector(up, halfH),
    center.clone().addScaledVector(right, halfW).addScaledVector(up, -halfH),
    center.clone().addScaledVector(right, -halfW).addScaledVector(up, -halfH)
  ];
}
